import { getData, setData } from './dataInteractors'

class LocalStorageActor {
  constructor(localStorageKey) {
    this.localStorageKey = localStorageKey
  }

  getData(path) {
    return getData(this.localStorageKey, path)
  }

  setData(path, data) {
    return setData(this.localStorageKey, path, data)
  }

  static clear(localStorageKey) {
    localStorage.removeItem(localStorageKey)
  }
}

export default LocalStorageActor
